import { ActionProps, WrapperAction } from '../ActionIcon';
import { DeleteOutlined } from '@vindr/icons';

const Delete = ({ onClick, disabled, title, tooltip, ...props }: ActionProps) => {
  return (
    <WrapperAction {...{ onClick, disabled, title, ...props }} title={tooltip || 'Delete'}>
      <DeleteOutlined />
    </WrapperAction>
  );
};

export default Delete;
